import { render, staticRenderFns } from "./ChangeLanguage.vue?vue&type=template&id=6e0083d2&scoped=true"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js"
import style0 from "./ChangeLanguage.vue?vue&type=style&index=0&id=6e0083d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0083d2",
  null
  
)

export default component.exports